var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1Ansight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 366.56 128.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 145.02,
    y1: 79.51,
    x2: 145.02,
    y2: 7.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6258b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb007b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 138.43,
    x2: 138.43,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 176.45,
    y1: 79.51,
    x2: 176.45,
    y2: 7.66,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 230.26,
    y1: 79.51,
    x2: 230.26,
    y2: 7.66,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 236.86,
    y1: 79.51,
    x2: 236.86,
    y2: 7.66,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 187.64,
    y1: 79.51,
    x2: 187.64,
    y2: 7.66,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 198.84,
    y1: 79.51,
    x2: 198.84,
    y2: 7.66,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 272.45,
    y1: 79.51,
    x2: 272.45,
    y2: 7.66,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 103,
    y1: 79.51,
    x2: 103,
    y2: 7.66,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 138.24,
    y1: 133.2,
    x2: 138.24,
    y2: 89.29,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 181.56,
    y1: 133.2,
    x2: 181.56,
    y2: 89.29,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 219.65,
    y1: 133.2,
    x2: 219.65,
    y2: 89.29,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 260.06,
    y1: 133.2,
    x2: 260.06,
    y2: 89.29,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 304.84,
    y1: 133.2,
    x2: 304.84,
    y2: 89.29,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 348.18,
    y1: 133.2,
    x2: 348.18,
    y2: 89.29,
    xlinkHref: "#b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.2,53.26c-1.16,0-2.17-.81-2.34-1.93-.05-.34-.42-3.4,1.83-5.8,1.61-1.71,4-2.55,7.16-2.5.54,0,3.58-.02,6.79-.04,4.07-.03,8.69-.07,11.3-.07,5.6,0,8.18,1.67,10.75,3.69,1,.79,1.13,2.18.3,3.12-.84.94-2.32,1.06-3.32.28-2.11-1.66-3.68-2.66-7.73-2.66-2.59,0-7.2.04-11.26.07-3.91.03-6.33.05-6.91.04-1.16-.02-2.72.14-3.54.99-.86.89-.71,2.29-.71,2.3.18,1.21-.72,2.32-2.01,2.48-.11.01-.22.02-.32.02Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196.95,45.21l-18.62.04c-6.23,0-11.29,4.86-11.29,10.61s4.21,13.97,4.21,13.97l32.77-.04s4.21-8.22,4.21-13.97-5.05-10.61-11.29-10.61Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M246.08,53.22c1.16,0,2.17-.81,2.34-1.93.05-.34.42-3.4-1.83-5.8-1.61-1.71-4-2.55-7.16-2.5-.54,0-3.58-.02-6.79-.04-4.07-.03-8.69-.07-11.3-.07-5.6,0-8.18,1.67-10.75,3.69-1,.79-1.13,2.18-.3,3.12.84.94,2.32,1.06,3.32.28,2.11-1.66,3.68-2.66,7.73-2.66,2.59,0,7.2.04,11.26.07,3.91.03,6.33.05,6.91.04,1.16-.02,2.72.14,3.54.99.86.89.71,2.29.71,2.3-.18,1.21.72,2.32,2.01,2.48.11.01.22.02.32.02Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.64,21.9c-17.99,0-39.99,2.87-36.26,14,1.12,3.33,6.83,6.48,8.15,5.57,1.31-.91-.48-2.06-1.97-3.67-6.02-6.44,9.76-8.79,13.12-9.23,3.34-.44,6.74-.59,10.11-.56,2.55.03,4.46,1.89,4.66,4.29.22,2.63.22,5.28.24,7.93,0,1.15.57,2.22,1.95,2.22s1.94-1.11,1.95-2.26c.02-2.64.02-5.29.24-7.93.2-2.4,2.11-4.26,4.66-4.29,3.37-.04,6.78.12,10.11.56,3.36.44,19.14,2.79,13.12,9.23-1.5,1.6-3.29,2.76-1.97,3.67,1.31.91,7.03-2.24,8.15-5.57,3.73-11.13-18.27-13.96-36.26-13.96Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M170.82,19.69h-23.29v-6.9h26.05s-2.76,2.35-2.76,6.9Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.29,39.39c-1.3,0-2.36-.99-2.36-2.22V12.28c0-1.22,1.06-2.22,2.36-2.22s2.36.99,2.36,2.22v24.9c0,1.22-1.06,2.22-2.36,2.22Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M204.47,19.65c1.49,0,23.29,0,23.29,0v-6.9s-26.05,0-26.05,0c0,0,2.76,2.35,2.76,6.9Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M235,39.35c-1.3,0-2.36-.99-2.36-2.22V12.23c0-1.22,1.06-2.22,2.36-2.22s2.36.99,2.36,2.22v24.9c0,1.22-1.06,2.22-2.36,2.22Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.54,70.3h-15.34c-1.3,0-2.36-.99-2.36-2.22s1.06-2.22,2.36-2.22h15.34c4.46,0,12.33-4.39,14.98-6.08,1.08-.69,2.54-.42,3.27.59.73,1.01.45,2.39-.63,3.08-1.1.7-10.93,6.85-17.63,6.85Z",
    fill: "url(#b)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M140.22,61.78h-11.02c-1.3,0-2.36-.99-2.36-2.22s1.06-2.22,2.36-2.22h11.02c3.46,0,5.77-2.02,5.79-2.04.94-.85,2.43-.83,3.33.05.91.88.88,2.28-.05,3.13-.15.13-3.67,3.28-9.07,3.28Z",
    fill: "url(#c)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M180.12,40.35s-6.55.02-7.36,1.22v-9.56s3.81-.77,5.7-.28,1.66,2.5,1.66,2.5v6.12Z",
    fill: "url(#d)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M230.74,70.26h15.34c1.3,0,2.36-.99,2.36-2.22s-1.06-2.22-2.36-2.22h-15.34c-4.46,0-12.33-4.39-14.98-6.08-1.08-.69-2.54-.42-3.27.59-.73,1.01-.45,2.39.63,3.08,1.1.7,10.93,6.85,17.63,6.85Z",
    fill: "url(#e)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M235.06,61.73h11.02c1.3,0,2.36-.99,2.36-2.22s-1.06-2.22-2.36-2.22h-11.02c-3.46,0-5.77-2.02-5.79-2.04-.94-.85-2.43-.83-3.33.05-.91.88-.88,2.28.05,3.13.15.13,3.67,3.28,9.07,3.28Z",
    fill: "url(#f)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M197.09,0c-1.93,0-16.96.04-18.89.04-4.2,0-4.02,4.65.08,4.65,1.65,0,4.91,0,7.51,0,0,1.82-.03,3.47.01,5.12.02.86-.19,1.31-1.2,1.65-3.77,1.25-6.14,3.78-7.17,7.63.98-.14,4.45-.39,5.28-.39,1.24-2.47,2.03-4.07,4.94-4.07s3.69,1.56,4.94,4.03c.83,0,4.3.25,5.28.39-1.03-3.85-3.4-6.39-7.17-7.63-1.02-.34-1.22-.79-1.2-1.65.04-1.65.01-3.29.01-5.12,2.6,0,5.86,0,7.51,0,4.1,0,4.28-4.65.08-4.65Z",
    fill: "url(#g)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M195.16,40.3s6.55.02,7.36,1.22v-9.56s-3.81-.77-5.7-.28-1.66,2.5-1.66,2.5v6.12Z",
    fill: "url(#h)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M261.47,46.5h21.96c4.07,0,7.38,3.31,7.38,7.38v15.96h-36.72v-15.96c0-4.07,3.31-7.38,7.38-7.38Z",
    fill: "url(#i)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.85,46.5h22.3c3.98,0,7.21,3.23,7.21,7.21v16.13h-36.72v-16.13c0-3.98,3.23-7.21,7.21-7.21Z",
    fill: "url(#j)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7,128.48c-3.16.15-6.33.31-9.49.47-.78.04-1.34-.12-1.68-.48-.35-.36-.52-.96-.52-1.8,0-14.31,0-28.63,0-42.94,0-.84.17-1.45.52-1.82.35-.37.91-.56,1.69-.56h27.32c.78,0,1.34.18,1.68.55.35.36.52.95.52,1.77,0,2.55,0,5.1,0,7.64,0,.81-.17,1.4-.52,1.77-.35.37-.91.56-1.69.56-5.21.06-10.41.12-15.62.19,0,2.26,0,4.53,0,6.79,3.55-.07,7.11-.14,10.66-.2.78-.01,1.34.16,1.68.52.35.36.52.95.52,1.76,0,2.58,0,5.16,0,7.74,0,.82-.17,1.41-.52,1.79-.35.38-.91.58-1.68.6-3.55.11-7.11.22-10.66.33,0,4.29,0,8.58,0,12.87,0,.83-.17,1.44-.52,1.82-.35.39-.91.6-1.68.64Z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M65.84,126.31c-9.03.29-18.05.62-27.08.99-.78.03-1.34-.13-1.68-.47-.35-.35-.52-.93-.52-1.74,0-2.58,0-5.16,0-7.74,0-.81.17-1.4.52-1.77.35-.37.91-.57,1.68-.59,2.29-.07,4.57-.13,6.86-.2,0-7.06,0-14.13,0-21.19-1.88.02-3.76.04-5.64.06-.78,0-1.34-.17-1.68-.53-.35-.36-.52-.94-.52-1.75,0-2.58,0-5.15,0-7.73,0-.81.17-1.4.52-1.76.35-.36.91-.54,1.68-.54h17.77c.78,0,1.34.18,1.68.53.35.36.52.93.52,1.72,0,10.27,0,20.53-.01,30.8,1.96-.05,3.92-.1,5.88-.14.78-.02,1.34.14,1.68.49.35.35.52.91.52,1.7,0,2.51,0,5.03,0,7.54,0,.79-.17,1.37-.52,1.73-.35.37-.91.56-1.69.58Z",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.16,123.46c0,.78-.17,1.35-.52,1.71-.35.36-.91.55-1.69.57-3,.08-6,.17-9.01.26-.78.02-1.34-.13-1.68-.48-.35-.34-.52-.91-.52-1.69,0-5.46,0-10.93,0-16.39,0-1.24.19-2.67.58-4.29.39-1.62.99-3.51,1.81-5.67,1.78-4.71,3.56-9.4,5.34-14.08.24-.7.62-1.22,1.13-1.55.51-.33,1.17-.49,1.99-.49h16.48c.78,0,1.42.16,1.93.49.51.33.89.83,1.13,1.53,1.77,4.61,3.55,9.21,5.32,13.8.82,2.1,1.42,3.94,1.81,5.52.39,1.58.58,2.97.58,4.19,0,5.35,0,10.7,0,16.04,0,.77-.17,1.33-.52,1.68-.35.35-.91.53-1.69.55-3.08.06-6.17.13-9.25.2-.82.02-1.42-.14-1.81-.48-.39-.34-.58-.89-.58-1.67,0-2.86,0-5.71,0-8.57-3.61.06-7.23.13-10.84.21,0,2.87,0,5.75,0,8.62ZM90.67,94.25c-.96,3.12-1.92,6.25-2.88,9.38,3.21-.04,6.41-.08,9.62-.12-.96-3.09-1.92-6.18-2.88-9.28-.16-.37-.34-.63-.52-.79-.18-.16-.4-.24-.64-.24-.51,0-1.02,0-1.53.01-.24,0-.46.09-.64.25-.18.17-.36.43-.52.8Z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M130.79,124.77c-3.06.04-6.13.09-9.19.15-.78.01-1.34-.15-1.69-.49-.35-.34-.52-.89-.52-1.66,0-13.08,0-26.17.01-39.25,0-.77.17-1.32.52-1.67.35-.34.91-.52,1.69-.52h6.37c.78,0,1.44.12,1.99.36.55.24,1.09.66,1.62,1.27,3.96,4.46,7.92,8.9,11.88,13.33,0-4.27,0-8.53,0-12.8,0-.76.17-1.31.52-1.65.35-.34.91-.51,1.68-.51h9.19c.78,0,1.34.17,1.68.51.35.34.52.89.52,1.65,0,12.94,0,25.88,0,38.83,0,.76-.17,1.31-.52,1.65-.35.34-.91.52-1.69.52-3.06.02-6.13.05-9.19.08-.78,0-1.34-.15-1.68-.49-.35-.34-.52-.89-.52-1.65,0-2.46,0-4.93,0-7.39-3.49-4.12-6.98-8.24-10.47-12.37,0,6.63,0,13.26,0,19.89,0,.76-.17,1.32-.52,1.67-.35.35-.91.52-1.69.54Z",
    fill: "url(#k)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M186,124.39c-6.46,0-12.91,0-19.37.04-.78,0-1.34-.16-1.68-.5-.35-.34-.52-.89-.52-1.64,0-2.33,0-4.67,0-7,0-.76.17-1.31.52-1.65.35-.34.91-.51,1.68-.51,5.49-.02,10.99-.03,16.48-.03.53,0,.93-.17,1.2-.51.26-.34.4-.75.4-1.23,0-.68-.14-1.17-.4-1.49-.27-.32-.67-.5-1.2-.54-3.06-.42-6.13-.83-9.19-1.25-2.86-.39-5.16-1.31-6.89-2.74-1.74-1.43-2.6-3.82-2.6-7.18,0-2.09,0-4.19,0-6.28,0-3.39,1.12-6,3.37-7.81,2.25-1.82,5.35-2.72,9.31-2.72h17.15c.78,0,1.34.17,1.69.51.35.34.52.89.52,1.64,0,2.37,0,4.75,0,7.12,0,.76-.17,1.31-.52,1.64-.35.34-.91.51-1.69.51-4.76,0-9.52,0-14.28,0-.53,0-.94.17-1.23.51-.29.34-.43.77-.43,1.29,0,.52.14.96.43,1.31.29.36.69.56,1.23.6,3.04.4,6.09.8,9.13,1.2,2.86.4,5.17,1.32,6.92,2.76,1.76,1.44,2.64,3.84,2.64,7.18,0,2.09,0,4.19,0,6.28,0,3.39-1.13,5.99-3.4,7.8-2.27,1.81-5.36,2.71-9.29,2.7Z",
    fill: "url(#l)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M206.6,124.46c-.78,0-1.34-.18-1.69-.52-.35-.34-.52-.89-.52-1.65,0-2.37,0-4.75,0-7.12,0-.76.17-1.31.52-1.64.35-.34.91-.5,1.69-.5,2.02,0,4.04.02,6.07.03,0-6.71,0-13.43,0-20.14-2.02,0-4.04,0-6.07-.01-.78,0-1.34-.17-1.69-.51-.35-.34-.52-.89-.52-1.65,0-2.41,0-4.83,0-7.24,0-.76.17-1.31.52-1.65.35-.34.91-.51,1.69-.51h26.1c.78,0,1.34.17,1.68.51.35.34.52.89.52,1.66,0,2.43,0,4.86,0,7.3,0,.76-.17,1.32-.52,1.66-.35.34-.91.51-1.68.51-1.98,0-3.96-.01-5.94-.02,0,6.74,0,13.47,0,20.21,1.98.02,3.96.04,5.94.06.78,0,1.34.19,1.68.53.35.35.52.9.52,1.66,0,2.39,0,4.78,0,7.17,0,.76-.17,1.32-.52,1.65-.35.34-.91.5-1.68.49-8.7-.12-17.4-.21-26.11-.26Z",
    fill: "url(#m)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M276.15,125.59c-6.43-.17-12.87-.32-19.3-.45-5.11-.1-8.9-1.18-11.37-3.24-2.47-2.06-3.71-5.18-3.71-9.37,0-6.29,0-12.57,0-18.86,0-4.19,1.23-7.29,3.7-9.3,2.47-2.01,6.26-3.03,11.36-3.03h15.32c.78,0,1.34.18,1.69.52.35.35.52.91.52,1.69,0,2.48,0,4.95,0,7.43,0,.78-.17,1.34-.52,1.68-.35.35-.91.52-1.69.51-4.25-.03-8.5-.05-12.74-.08-1.27,0-2.21.24-2.82.74-.61.5-.92,1.26-.92,2.27,0,4.84,0,9.69,0,14.53,0,1.01.24,1.77.71,2.26.47.49,1.17.75,2.11.76,1.98.03,3.96.06,5.94.1,0-3.17,0-6.35,0-9.52,0-.77.17-1.33.52-1.67.35-.34.91-.51,1.68-.5,3.17.03,6.33.07,9.5.11.78,0,1.34.19,1.68.54.35.35.52.92.52,1.7,0,6.34,0,12.67,0,19.01,0,.78-.17,1.34-.52,1.68-.35.34-.91.5-1.68.48Z",
    fill: "url(#n)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M297.53,126.2c-3.17-.1-6.33-.2-9.5-.29-.78-.02-1.34-.21-1.68-.57-.35-.36-.52-.93-.52-1.72,0-13.35-.01-26.7-.02-40.06,0-.78.17-1.35.52-1.7.35-.35.91-.53,1.68-.53h9.5c.78,0,1.34.18,1.68.53.35.35.52.93.52,1.72,0,4.51,0,9.03,0,13.54,3.41.04,6.82.08,10.23.12,0-4.55,0-9.1,0-13.65,0-.8.17-1.37.52-1.73.35-.36.91-.54,1.68-.54h9.5c.78,0,1.34.18,1.68.54.35.36.52.94.52,1.75,0,13.74,0,27.48.01,41.21,0,.81-.17,1.38-.52,1.73-.35.35-.91.5-1.68.47-3.16-.12-6.33-.24-9.49-.35-.78-.03-1.34-.23-1.68-.59-.35-.37-.52-.95-.52-1.75,0-4.65,0-9.31,0-13.96-3.41-.08-6.82-.15-10.23-.22,0,4.62,0,9.24,0,13.85,0,.79-.17,1.36-.52,1.7-.35.34-.91.5-1.68.48Z",
    fill: "url(#o)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M353.14,128.4c-3.31-.16-6.61-.31-9.92-.46-.78-.03-1.34-.24-1.68-.62-.35-.38-.52-.98-.52-1.8,0-10.57,0-21.14,0-31.71-3-.04-6-.07-9.01-.1-.78,0-1.34-.2-1.68-.56-.35-.37-.52-.95-.52-1.76,0-2.58,0-5.16,0-7.74,0-.81.17-1.4.52-1.76.35-.36.91-.54,1.68-.54h32.35c.78,0,1.34.19,1.69.56.35.37.52.98.52,1.82v8.02c0,.84-.17,1.45-.52,1.82-.35.37-.91.55-1.69.54-3-.04-6-.08-9-.12,0,10.72,0,21.44,0,32.16,0,.83-.17,1.42-.52,1.78-.35.36-.91.51-1.68.48Z",
    fill: "url(#p)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF1Ansight);
export default __webpack_public_path__ + "static/media/F1Ansight.ddf3bfa517971ba45cc01a7573060a12.svg";
export { ForwardRef as ReactComponent };